import styled from "styled-components";

export const Title = styled.h5`
  font-size: 1.25rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 1rem;
`;

export const SubTitle = styled.h5`
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 1rem;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 20px;
`;

export const CommandList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 0px;
`;

export const CommandItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f9f9f9;
  padding: 12px 16px;
  border-radius: 10px;
  border: 1px solid #ddd;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f0f8ff;
  }
`;

export const CommandDescription = styled.p`
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
  color: #333;
`;

export const CommandButton = styled.button`
  padding: 6px 12px;
  background-color: #007bff;
  color: white;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #0056b3;
  }
`;
